import getHours from 'date-fns/get_hours';
import getMinutes from 'date-fns/get_minutes';

export const MILLISECONDS_IN_SECOND = 1000;
export const MINUTES_IN_HOUR = 60;
export const MINUTES_IN_DAY = 1440;
export const MINUTES_IN_WEEK = 10080;
export const SECONDS_IN_MINUTE = 60;

export function secondsToMilliseconds(n) {
  return n * MILLISECONDS_IN_SECOND;
}

export function minutesToMilliseconds(n) {
  return secondsToMilliseconds(n) * SECONDS_IN_MINUTE;
}

export const minutesOfDay = date =>
  getMinutes(date) + getHours(date) * MINUTES_IN_HOUR;


// WEBPACK FOOTER //
// ./src/util/time.js